import type {
  UpsertProcessorMutation,
  UpsertProcessorMutationVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const UPSERT_PROCESSOR: TypedDocumentNode<
  UpsertProcessorMutation,
  UpsertProcessorMutationVariables
> = gql`
  mutation UpsertProcessor($input: UpsertProcessorInput!) {
    upsertProcessor(input: $input) {
      message
      processor {
        id
        fileId
        createdAt
        updatedAt
      }
    }
  }
`;
